import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { calendarColors } from '@/styles/theme';

/**
 * Whole-day sick leave or vacation on a mechanic's row (#2261).
 *
 * A shift and an absence cannot hold at once, so the shift bar is gone on
 * these days — this block is what says why the row is empty. Hatched rather
 * than solid so it never reads as bookable work.
 */
export function AbsenceCalendarItem({ labelKey }: { labelKey: string }) {
  const { t } = useTranslation('calendar');
  const theme = useTheme();
  const label = t(labelKey);
  const tint = labelKey === 'absence.sickLeave' ? theme.palette.error.main : theme.palette.info.main;
  return (
    <Tooltip title={label}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          px: 1,
          borderRadius: 0.5,
          border: `1px solid ${calendarColors.itemBorder}`,
          color: tint,
          backgroundColor: alpha(tint, 0.12),
          backgroundImage: `repeating-linear-gradient(135deg, ${alpha(tint, 0.18)} 0 6px, transparent 6px 12px)`,
          overflow: 'hidden',
        }}
      >
        <Typography variant="caption" fontWeight={600} noWrap>{label}</Typography>
      </Box>
    </Tooltip>
  );
}
